import React from "react";
import { Provider } from "react-redux";
import { Route, Routes } from "react-router-dom";
import store from "../redux/store";

// Pages
import Landing from "../pages/landing/index";
import Search from "../pages/search/index";
import Movie from "../pages/movie/index";
import Genres from "../pages/genres/index";
import Genre from "../pages/genre/index";
import Login from "../pages/auth/login";
import Details from "../pages/details/index";

// Components
// import Breadcrumb from "../components/breadcrumb/index";
import Header from "../components/Header/index";
import Footer from "../pages/landing/Footer/index";

const Index = () => {
  return (
    <>
      <div className="2xl:!container mx-auto justify-center text-slate-900">
        <Provider store={store}>
          <div className="px-4 lg:px-24">
            <Header />
          </div>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/search" element={<Search />} />
            <Route path="/movies" element={<Movie />} />
            <Route path="/genres" element={<Genres />} />
            <Route path="/genres/:id" element={<Genre />} />
            <Route path="/auth-login" element={<Login />} />
            <Route path="/:id" element={<Details />} />
            <Route path="/:name/:id" element={<Details />} />
            <Route path="/:name/:genre/:id" element={<Details />} />
          </Routes>
          <Footer />
        </Provider>
      </div>
    </>
  );
};

export default Index;
